var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    key: 'plan',
    staticClass: "-mt-12 sm-md:mt-0 plan--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "section--content flex flex-col"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Choose your plan")]), _vm._v(" "), _c('progress-indicator', {
    staticClass: "mt-6",
    attrs: {
      "step": 2
    }
  }), _vm._v(" "), _c('plan-picker', {
    attrs: {
      "billing-cycle": _vm.plan.billingCycle,
      "plans": _vm.plans,
      "selected-plan": _vm.plan.selectedPlan
    },
    on: {
      "update:billingCycle": function ($event) {
        return _vm.$set(_vm.plan, "billingCycle", $event);
      },
      "update:billing-cycle": function ($event) {
        return _vm.$set(_vm.plan, "billingCycle", $event);
      },
      "update:selectedPlan": function ($event) {
        return _vm.$set(_vm.plan, "selectedPlan", $event);
      },
      "update:selected-plan": function ($event) {
        return _vm.$set(_vm.plan, "selectedPlan", $event);
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-8 self-center sm:w-full",
    on: {
      "click": _vm.continueButtonAction
    }
  }, [_vm._v("\n\t\t\t\tContinue\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "disclaimer mt-8 font-medium text-sm leading-6 text-center"
  }, [_vm._v("\n\t\t\t\tApplying for Extra will not affect your credit score.\n\t\t\t")])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };